import {ComponentPropsWithoutRef, MouseEventHandler} from "react";
import {Link as BaseLink} from "@inertiajs/react";
import classNames from "classnames";
import {isCurrentWindowNavigation, startNavigationLoader} from "../../lib/navigation/navigationLoader";

type BaseLinkProps = ComponentPropsWithoutRef<typeof BaseLink>;

type Props = BaseLinkProps & {
    active?: boolean;
    dataSrc?: string;
    showLoader?: boolean;
};

export const Link = (
    {
        className,
        active = false,
        dataSrc,
        showLoader = true,
        onClick,
        children,
        ...otherProps
    }: Props
) => {
    const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
        onClick?.(event);

        if (event.defaultPrevented) {
            return;
        }

        if (showLoader && isCurrentWindowNavigation(event)) {
            startNavigationLoader();
        }
    };

    return (
        <BaseLink
            {...otherProps}
            onClick={handleClick}
            className={classNames(className, {active})}
            data-src={dataSrc}
        >
            {children}
        </BaseLink>
    );
}
